module.exports = __webpack_public_path__ + "static/img/15.8f4ff8e1.png";